/**
 * Certaines apps tierces (ex. Givy - "Offrir en cadeau") ajoutent un item au panier
 * en appelant directement l'API /cart/add.js sans passer par product-form.js.
 * Le thème ne le sait donc jamais et le tiroir panier (cart-drawer) ne se met pas
 * à jour tant que la page n'est pas rechargée.
 *
 * Ce script intercepte tout appel /cart/add réussi (fetch et XHR), peu importe qui
 * l'a déclenché, puis recharge le tiroir panier via la Section Rendering API — la
 * même méthode que product-form.js utilise pour un ajout "normal" — et l'ouvre.
 * Pas de reload de page.
 */
(function () {
  if (window.__cartAddSyncPatched) return;
  window.__cartAddSyncPatched = true;

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;

    var sectionIds = drawer.getSectionsToRender().map(function (section) {
      return section.id;
    });

    // On passe par /cart (jamais mis en cache par le CDN Shopify, contrairement à une
    // page produit/collection) pour être certain d'avoir le contenu panier à jour.
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var url = cartUrl + '?sections=' + encodeURIComponent(sectionIds.join(',')) + '&_=' + Date.now();

    fetch(url, { cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        drawer.renderContents({ id: null, sections: sections });
        // product-form.js fait ce nettoyage après un ajout "normal" (voir son .finally()) ;
        // comme on contourne product-form.js ici, on le refait nous-mêmes, sinon la règle
        // CSS ".is-empty .cart__contents" laisse le contenu du tiroir masqué (display:none).
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-app' });
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  // fetch()
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var trackThisCall = isCartAddUrl(url);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (trackThisCall && response.ok) {
          refreshCartDrawer();
        }
        return response;
      });
    };
  }

  // XMLHttpRequest (au cas où une app ajoute au panier sans fetch)
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAddUrl(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          refreshCartDrawer();
        }
      });
    }
    return originalOpen.apply(this, arguments);
  };
})();
